function manageOtherValue() {
  /**
   * Manage selects which can have an 'Other' value and a 'Specify' input.
   * When 'Other' is selected, show the 'Specify' input, otherwise hide it.
   */
  const selectId = $(this).attr('id');
  const specifyInput = $(`#${selectId}_other`);
  // Hide the full 'col-sm-6', not just the input.
  const inputBlock = specifyInput.closest('div[class^=col-]');

  if ($(this).find(':selected').val() === 'Other') {
    inputBlock.removeClass('hidden');
  } else {
    inputBlock.addClass('hidden');
    specifyInput.val('');
  }
}
$(document).on('change', '.has_option_other', manageOtherValue);

function manageOtherValues() {
  /**
   * On page load, manage all the selects with 'Other' value.
   */
  $('.has_option_other').each(manageOtherValue);
}
// Not centralizing this as it is deprecated.
$(manageOtherValues);
$(document).on('pjax:end', manageOtherValues);

$(document).on('input', '.specify_input', function updateOtherValue() {
  /**
   * Manage the 'Specify' input for a select with an 'Other' value.
   * When nothing is entered in the input, keep the 'Other' value, otherwise, use the user-entered input.
   */
  // Go from the input text to the select and the selected option.
  const otherOption = $(this).closest('.row').find('option:selected');
  if ($(this).val() === '') {
    otherOption.val('Other');
  } else {
    otherOption.val($(this).val());
  }
});

$(document).on('click', '#expatriation-add-button', function addExpatriation() {
  const expatriationLines = $('.expatriation_line');

  let expatriationsCounter = 0;
  // Get the current biggest counter value.
  expatriationLines.each(function getCounter() {
    if ($(this).data('expatriations-counter') > expatriationsCounter) {
      expatriationsCounter = $(this).data('expatriations-counter');
    }
  });
  expatriationsCounter += 1;

  const newExpatriationDivID = `expatriation-${expatriationsCounter}`;
  const newExpatriationDiv = $('#expatriation__reference')
    .clone()
    .removeClass('hidden')
    .attr('id', newExpatriationDivID)
    .attr('data-expatriations-counter', expatriationsCounter);

  newExpatriationDiv.find('#expatriation-location')
    .removeAttr('id')
    .attr('name', `employee-expatriation-${expatriationsCounter}-location`);

  newExpatriationDiv.find('#expatriation-start_date')
    .removeAttr('id')
    .attr('name', `employee-expatriation-${expatriationsCounter}-start_date`);

  newExpatriationDiv.find('#expatriation-end_date')
    .removeAttr('id')
    .attr('name', `employee-expatriation-${expatriationsCounter}-end_date`);

  $('#expatriations-block').append(newExpatriationDiv);

  if (expatriationLines.length === 10) {
    $(this).prop('disabled', true);
  }
});

$(document).on('click', '.expatriation-delete-button', function removeExpatriation() {
  $(this).closest('.expatriation_line').remove();
  $('#expatriation-add-button').prop('disabled', false);
});
